export interface Address {
  name: string;
  street: string;
  city: string;
  zip_code: string;
  country: string;
  phone_number: string;
  email?: string;
}

export interface BillingAddress {
  company_name: string;
  vat_id?: string;
  street: string;
  city: string;
  zip_code: string;
  country: string;
}

export interface ProviderConnectionData {
  stock_provider: boolean;
  orders_provider: boolean;
  store_shipping_address?: Address;
  store_billing_address?: BillingAddress;
  auto_order_handler: string | null;
  test_mode: boolean;
  local_pickup_shipping_methods: string[];
  local_pickup_batch_threshold: number;
}

export type StepName = 'capabilities' | 'addresses' | 'auto_order';

export interface ProviderConfig {
  steps: StepName[];
  requiresEmail: boolean;
  supportedHandlers: string[];
}

const defaultConfig: ProviderConfig = {
  steps: ['capabilities', 'addresses', 'auto_order'],
  requiresEmail: false,
  supportedHandlers: ['bigbuy'],
};

const providerConfigs: Record<string, Partial<ProviderConfig>> = {
  bigbuy: {
    requiresEmail: true,
    supportedHandlers: ['bigbuy'],
  },
  goldsneakers: {
    supportedHandlers: ['goldsneakers'],
  },
  turumpurum: {
    requiresEmail: true,
    supportedHandlers: ['turumpurum'],
  },
};

export function getProviderConfig(providerType: string): ProviderConfig {
  const overrides = providerConfigs[providerType] ?? {};
  return { ...defaultConfig, ...overrides };
}
